import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';

export class BcfRouterExternalRedirectorService {
  public redirectToExternalUrl(url: string, openInNewTab: boolean = false): void {
    window.open(url, openInNewTab ? '_blank' : '_self');
  }
}

export function provideBcfRouterExternalRedirectorService(): BcfRouterExternalRedirectorService {
  return provideSingleton(BcfRouterExternalRedirectorService, () => new BcfRouterExternalRedirectorService());
}
